module.exports = __webpack_public_path__ + "img/ProduuzIT.31acda31.png";